import { getAxiosInstance } from "../utils/apiClient";
import { getTokens } from "../utils/tokens";

const axiosInstance = getAxiosInstance();

export const getAgeProofs = (options) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/user/age-proofs", {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
        params: options,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.data);
      });
  });
};
export const getAllUsers = (options) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/user/age-proofs/allUsers", {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
        params: options,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.data);
      });
  });
};

export const getAllViewers = (options) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/user/age-proofs/allViewers", {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
        params: options,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.data);
      });
  });
};

export const approveAgeProof = (userIds, approve = true) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .patch(
        "/api/user/approve-age-proofs",
        {
          ids: userIds,
        },
        {
          headers: {
            "Content-Type": "application/json",
            [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
            [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
              `Bearer ${tokens.firebase_token}`,
            "ngrok-skip-browser-warning": "true",
          },
          params: {
            approve: approve,
          },
        },
      )
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.data);
      });
  });
};
export const approveRevoke = (userIds, approve = true) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .patch(
        "/api/user/revoke",
        {
          ids: userIds,
        },
        {
          headers: {
            "Content-Type": "application/json",
            [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
            [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
              `Bearer ${tokens.firebase_token}`,
            "ngrok-skip-browser-warning": "true",
          },
          params: {
            approve: approve,
          },
        },
      )
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.data);
      });
  });
};


export const announcementAPI = async (message) => {
  const tokens = getTokens();

  try {
    const res = await axiosInstance.post(
      '/api/dashboard/platform-updates',
      { message },
      {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      }
    );
    return res.data;
  } catch (err) {
    throw err?.response?.data || err;
  }
};